import { render, staticRenderFns } from "./DementiaInsurance.vue?vue&type=template&id=7488930b&"
import script from "./DementiaInsurance.vue?vue&type=script&lang=js&"
export * from "./DementiaInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports